import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { AgencyResponse } from "./interface";

//SECTION - Get All Farmer Groups
const getAgency = async (
  query?: string
): Promise<ApiResponse<DataPaginate<AgencyResponse>>> => {
  return await fetcher(query ? `master/instansi?${query}` : `master/instansi`);
};

export const useGetAgency = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<AgencyResponse>>, Error>({
    queryKey: ["useGetAgency", query],
    queryFn: () => getAgency(query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};

const getAgencyById = async (
  id: string
): Promise<ApiResponse<DataObject<AgencyResponse>>> => {
  return await fetcher(`master/instansi/${id}`);
};

export const useGetAgencyById = (id: string) => {
  return useQuery<ApiResponse<DataObject<AgencyResponse>>, Error>({
    queryKey: ["useGetAgencyById", id],
    queryFn: () => getAgencyById(id),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};
